import React from 'react';
import { Box, Button, InputAdornment, TextField } from '@mui/material';
import { Colors } from '../../../../../assets/theme/Colors';
import { formatNumber } from '../../../../../helpers/formatters';

const RescuedItem = ({ index, itemLbs, description, disabled, onItemWeightChange }) => {
  const charWidth = 8;
  const minWidth = 80;
  const maxWidth = 200;
  const additionalWidth = itemLbs ? formatNumber(itemLbs).length * charWidth + 30 : 0;
  const dynamicWidth = additionalWidth > minWidth ? Math.min(additionalWidth, maxWidth) : minWidth;

  return (
    <Box gap="20px" display="flex" alignItems="center" sx={{ marginTop: '1rem' }}>
      <Box data-introid="item-lbs">
        <TextField
          variant="standard"
          name={`items[${index}].lbs`}
          id={`items[${index}].lbs`}
          data-testid={`items[${index}].lbs`}
          value={formatNumber(itemLbs)}
          placeholder="Lbs"
          style={{
            width: dynamicWidth,
            minWidth,
            maxWidth,
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">lbs</InputAdornment>,
            min: 0,
            inputMode: 'numeric', // support for numeric keyboard on mobile devices
          }}
          disabled={disabled}
          onChange={({ target }) => onItemWeightChange(target.value, index)}
        />
      </Box>
      <Box>
        <Button
          size="small"
          color="secondary"
          variant="contained"
          disabled={disabled}
          disableRipple
          disableFocusRipple
          disableElevation
          fullWidth
          sx={{
            borderRadius: '28px',
            cursor: 'default',
            '&:hover': {
              backgroundColor: Colors.secondaryColor,
            },
            fontSize: '12px',
          }}
          data-testid={description.name}
        >
          {description.name}
        </Button>
      </Box>
    </Box>
  );
};

export default RescuedItem;
